import React, {useState, useEffect, useContext} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../constants/general-constants";
import {GREY_FONT} from "../constants/general-constants";
import {store} from '../context/store';
import {JWT} from "../constants/local-storage";
import {useHistory} from 'react-router-dom';
import {colorFunctions} from "../constants/colors";

export default function MapListLocation({location}){
	const globalState = useContext(store);
	const [thisBackground, setThisBackground] = useState("");
	const [thisForeground, setThisForeground] = useState("black");
	const [photoSource, setPhotoSource] = useState("");
	const [photoDisplay, setPhotoDisplay] = useState('none');
	const [locationId, setLocationId] = useState("-100");
	
	const history = useHistory();
	
	useEffect(() => {
		try{
			setLocationId(location.id);
			loadPhoto(globalState.state.client.resourceFolderUrl + "/buildingphotos/" + location.code + "/" + location.photoFile);
		}
		catch(e){}
		
	}, [location]);
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		minHeight:"60px",
		alignItems:"center",
		borderBottom:"1px solid #f5f5f5",
		backgroundColor:thisBackground,
		cursor:"pointer"
	};
	
	const photoContainer = {
		display:"flex",
		margin:"5px",
		marginLeft:"20px",
		height:"50px",
		backgroundColor:"#f5f5f5",
		width:"50px",
		borderRadius:"25px"
	};
	
	const nameContainer = {
		display:"flex",
		fontSize:'14px',
		marginLeft:"20px",
		width:"400px",
		color:thisForeground
	};
	
	const typeContainer = {
		display:"flex",
		fontSize:'14px',
		marginLeft:"20px",
		width:"200px",
		color:thisForeground
	};
	
	const descriptionContainer = {
		display:"flex",
		fontSize:'14px',
		marginLeft:"20px",
		flexGrow:"1",
		color:thisForeground
	};
	
	const handleMouseOver = () => {
		setThisBackground(colorFunctions.getSecondaryColor());
		setThisForeground("white");
	};
	
	const handleMouseOut = () => {
		setThisBackground("");
		setThisForeground("black");
	};
	
	const handleClick = () => {
		history.push('/facility/' + locationId);
	};
	
	const loadPhoto= (imageUrl) => {
		
		fetch(imageUrl, {
	    	method:"GET",
	    	headers:{
	    		'Authorization': localStorage.getItem(JWT)
	    	}
	    }).then(result => result.blob())
	    .then(result => {
	    	if(result.size > 1000){
	    		setPhotoSource(URL.createObjectURL(result));
		    	setPhotoDisplay('flex');
		    
	    	}
	    	else{
	    		
	    	}
	    });
	};
	
	const iconStyle = {
		width:"20px",
		height:"30px"
	};
	
	const photo = {
		display:photoDisplay,
		height:"50px",
		width:"50px",
		borderRadius:"25px"	
	};
	return (
		<div style={thisContainer} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onClick={handleClick}>
			<div style={photoContainer}>
				<img src={photoSource} style={photo}/>
			</div>
			<div style={nameContainer}>
				{location.name}
			</div>
			<img src={location.icon} style={iconStyle}/>
			<div style={typeContainer}>
				{location.type}
			</div>
			<div style={descriptionContainer}>
				{location.description}
			</div>
		</div>
	);
}